"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceResponseToJSON = exports.PriceResponseFromJSONTyped = exports.PriceResponseFromJSON = exports.instanceOfPriceResponse = void 0;
var runtime_1 = require("../runtime");
var Premium_1 = require("./Premium");
/**
 * Check if a given object implements the PriceResponse interface.
 */
function instanceOfPriceResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPriceResponse = instanceOfPriceResponse;
function PriceResponseFromJSON(json) {
    return PriceResponseFromJSONTyped(json, false);
}
exports.PriceResponseFromJSON = PriceResponseFromJSON;
function PriceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'costMicro': !(0, runtime_1.exists)(json, 'cost_micro') ? undefined : json['cost_micro'],
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
        'costType': !(0, runtime_1.exists)(json, 'cost_type') ? undefined : json['cost_type'],
        'cost': !(0, runtime_1.exists)(json, 'cost') ? undefined : json['cost'],
        'baseCostMicro': !(0, runtime_1.exists)(json, 'base_cost_micro') ? undefined : json['base_cost_micro'],
        'premiums': !(0, runtime_1.exists)(json, 'premiums') ? undefined : (json['premiums'].map(Premium_1.PremiumFromJSON)),
    };
}
exports.PriceResponseFromJSONTyped = PriceResponseFromJSONTyped;
function PriceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'cost_micro': value.costMicro,
        'currency': value.currency,
        'cost_type': value.costType,
        'cost': value.cost,
        'base_cost_micro': value.baseCostMicro,
        'premiums': value.premiums === undefined ? undefined : (value.premiums.map(Premium_1.PremiumToJSON)),
    };
}
exports.PriceResponseToJSON = PriceResponseToJSON;
